<template>
  <div>
    <div class="vx-row">
      <div class="vx-col text-center w-full mb-8">
        <h1>Bem vindo(a)!</h1>
      </div>
      <div class="vx-col text-center w-full mb-8">
        <vx-card>
          <iframe width="560" height="315" src="https://www.youtube.com/embed/WnHu-5lX_e0?si=4D0ZTwfFBnQjf1Zp" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </vx-card>
      </div>
      <div class="vx-col text-center w-full mb-8">
        <vx-card>
          <iframe width="560" height="315" src="https://www.youtube.com/embed/WnHu-5lX_e0?si=4D0ZTwfFBnQjf1Zp" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </vx-card>
      </div>
      <div class="vx-col text-center w-full mb-8">
        <vx-card>
          <iframe width="560" height="315" src="https://www.youtube.com/embed/WnHu-5lX_e0?si=4D0ZTwfFBnQjf1Zp" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchQuery: '',
      videos: []
    }
  },
  computed: {
    videosList() {
      return this.videos.filter(
        (item) =>
          item.title.toLowerCase().includes(this.searchQuery.toLowerCase())
      ).sort((a, b) => a.sort - b.sort)
    }
  },
  mounted() {
    this.$api
    .get("/api/v1/videos")
    .then(response => {
      this.videos = response.data;
    })
    .catch(() => {});
  }
}
</script>

